import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { ApContentModule, ApContentService } from '@ap/content';
import { ApScrollService } from '@ap/scroll';
import { ApButtonComponent } from '@ap/button';
import { ApPanelComponent } from '@ap/panel';

import content from './betaalverzoek-info.content.json';

/**
 * @ngdoc component
 * @name BetaalverzoekInfoComponent
 * @description Renders the footer component
 */
@Component({
    selector: 'betaalverzoek-info',
    templateUrl: './betaalverzoek-info.component.html',
    imports: [ApContentModule, ApButtonComponent, ApPanelComponent],
    providers: [ApScrollService]
})
export class BetaalverzoekInfoComponent implements OnInit {
    public showInfo = false;

    public constructor(
        private readonly contentService: ApContentService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly scrollService: ApScrollService
    ) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public toggleAndScrollTo(name: string): void {
        this.toggleShowInfo();
        this.changeDetectorRef.detectChanges();
        this.scrollService.scrollTo(name);
    }

    public toggleShowInfo(): void {
        this.showInfo = !this.showInfo;
    }
}
